// Dashboard screen constants.

import dayjs from 'dayjs';
import { TDashboardFilters } from './Dashboard';

export const independentSystemWidgetIds = {
  help: 'insights.help',
  status: 'insights.status',
};

// RSS feed display types (module.display[0].view)
export const rssDisplayTypes: ['listcard', 'imagecard'] = ['listcard', 'imagecard'];

export const dashboardTitleHeight = 68;

// ISO 8601 format (YYYY-MM-DD) for universal browser compatibility including Safari
export const DASHBOARD_DATE_FILTER_FORMAT = 'YYYY-MM-DD';

/**
 * CMSADMIN-1810
 * Althought ticket asks for "web" as default
 * platform value this is not a valid change
 * to make on the client side, its API level.
 *
 *
 * TNCMS-556658: Remove platform default value.
 * Ticket says sending a default value for platform
 * on dashboards caues issues. In light of this, for now we will
 * respect whatever the dynfield specifies for default, null included.
 * We will still need to santize string 'all' out of query for safety
 * in one area regarding videoplays dashboard until API updates it.
 *
 * NOTE: The API is inconsistent for the platform dynfield.
 * Home, Editorial, Editorial KPI dashboards specify multiselect.
 * Absence of a selection is equivalent to "all" (no param sent).
 * HOWEVER: The beta videoplays dashboard is still using the
 * older single select dropdown with a string "all" option
 * that is provided by the API as an option.
 * That string "all" is not a valid param, we remove it.
 *
 * TNCMS-556685 will correct the videoplays dashboard.
 *
 */

// Default filters for Dashboards
export const DASHBOARD_DEFAULT_FILTERS: TDashboardFilters = {
  assetUUID: undefined,
  userID: undefined,
  query: undefined,
  page: 1,
  pageSize: 25,
  sort: undefined,
  sortDir: 'desc',
  // default to a 31-day range ending yesterday (month-day-year only)
  dateRangeFilter: [
    dayjs().subtract(31, 'day').format(DASHBOARD_DATE_FILTER_FORMAT),
    dayjs().subtract(1, 'day').format(DASHBOARD_DATE_FILTER_FORMAT),
  ],
  localOnly: false,
  subscriberOnly: false,
  purgeCache: false,
};

export const TICKER_DASHBOARDS = {
  editorialSearch: 'editorial.search',
  userSearch: 'subscription.search',
  emailReach: 'emailreach.ticker',
};
